import { Box, DialogContent, DialogContentText, Button, Select, FormControl, MenuItem, InputLabel, TextField, InputAdornment, OutlinedInput, Typography, Dialog, IconButton } from "@mui/material";
import { useState } from "react";
import validator from 'validator';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, fetchCreatedOrer } from "../../store/slice/orderSlice";
import { getNiceCoins } from "../../utils/function";
import { PaymentMethods } from "../../utils/paymentMethod";

const formatter = new Intl.NumberFormat('ru-RU');

const OrderBox = ({ game, isMobile }) => {

    const dispatch = useDispatch()
    const { isLoading, error, data } = useSelector(state => state.order)
    const { user } = useSelector(state => state.user)

    const [name, setName] = useState('')
    const [coin, setCoin] = useState('')
    const [amount, setAmount] = useState('')
    const [mail, setMail] = useState('')
    const [code, setCode] = useState('')
    const [errorMail, setErrorMail] = useState(false)
    const [errorName, setErrorName] = useState(false)
    const [errorAmount, setErrorAmount] = useState(false)
    const [errorCoin, setErrorCoin] = useState(false)
    const [server, setServer] = useState(game['server'][0]['name'])
    const [serverArray, setServerArray] = useState(game['server'])
    const [openError, setOpenError] = useState(false)
    const [showLoading, setShowLoading] = useState('hidding')
    const [openErrorRequest, setOpenErrorRequest] = useState(false)
    const [showPaymentWindow, setShowPaymentWindow] = useState(false)
    const [showPMWindow, setShowPMWindow] = useState(false)//Измениить
    const [paymentMethod, setPaymentMethod] = useState(PaymentMethods?.[0]?.value || 'intellectmoney')

    const [exchane, setExchange] = useState(getNiceCoins(game['server'][0]['rate']))

    const handleAmountChange = (e) => {
        const value = e.target.value.replace(/\s+/g, '');

        const rate = game.server.find(item => item.name === server)

        if (Number(value)) {
            setAmount(formatter.format(value))
            setCoin(formatter.format(value * rate.rate))
        } else {
            setAmount('')
            setCoin('')
        }
    }

    const handleCoinChange = (e) => {
        const value = e.target.value.replace(/\s+/g, '');
        const rate = game.server.find(item => item.name === server)
        if (Number(value)) {
            setAmount(formatter.format(value / rate.rate))
            setCoin(formatter.format(value))
        } else {
            setAmount('')
            setCoin('')
        }
    }

    const handleMail = (e) => {
        const value = e.target.value
        if (validator.isEmail(value)) {
            setErrorMail(false)
        } else {
            setErrorMail(true)
        }
    }

    const handleChangeServer = (e) => {
        setServer(e.target.value)
        setAmount('')
        setCoin('')
        const rate = game.server.find(item => item.name === e.target.value)
        setExchange(getNiceCoins(rate.rate))
    }


    ////////

    const handleOrder = async (selectedPaymentMethod = paymentMethod) => {
        if (validator.isEmail(mail)
            && !validator.isEmpty(name)
            && !validator.isEmpty(amount)
            && !validator.isEmpty(coin)) {
            const price = parseFloat(amount.replace(/\s+/g, '').replace(',', '.'));


            const result = await dispatch(fetchCreatedOrer({
                game: game.name,
                name: name,
                server: server,
                price: price,
                coin: coin,
                mail: mail,
                user_id: user ? user.id : 0,
                payment_method: selectedPaymentMethod
            }));


            if (fetchCreatedOrer.fulfilled.match(result)) {
                setShowPaymentWindow(true)
            }


        } else {
            if (validator.isEmail(mail)) {
                setErrorMail(false)
            } else {
                setErrorMail(true)
            }
            setErrorName(validator.isEmpty(name))
            setErrorAmount(validator.isEmpty(amount))
            setErrorCoin(validator.isEmpty(coin))
        }
    }

    const handlePM = () => {
        setShowPMWindow(true)
    }

    const handleSelectPaymentMethod = (methodValue) => {
        setPaymentMethod(methodValue)
        setShowPMWindow(false)
        handleOrder(methodValue)
    }

    return (
        <>
            {
                isLoading &&

                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    className={"loading"}>
                    <CircularProgress />
                </Box>
            }

            {error &&
                <Dialog
                    open={true}
                    onClose={() => dispatch(clearErrors())}

                >

                    <DialogContent>
                        <DialogContentText >
                            {error}
                        </DialogContentText>
                    </DialogContent>

                </Dialog>
            }

            <Dialog
                open={showPaymentWindow}
                onClose={() => setShowPaymentWindow(false)}
            >

                <DialogContent>

                    <Typography align='center' variant="h5" sx={{ mb: 2, mt: 2 }}>
                        Ваш заказ #{data?.orderId} принят!
                    </Typography>
                    <Typography align='center' variant="h6">
                        на сумму {data?.recipientAmount} ₽
                    </Typography>

                    {
                        paymentMethod === 'usdt' ?
                            <Typography align='center' variant="body1" sx={{ mt: 2 }}>
                                Оплатите заказ, отправив {data?.recipientAmount} USDT на кошелек {data?.link}
                            </Typography>
                            :
                            <Box
                                display='flex'
                                justifyContent='center'
                                alignItems='center'
                                mt={2}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => {

                                        dispatch(clearErrors())
                                        setAmount('')
                                        setCoin('')
                                        setServer(game['server'][0]['name'])
                                        setExchange(getNiceCoins(game['server'][0]['rate']))
                                        setServerArray(game['server'])
                                        setMail('')
                                        setName('')

                                        setShowPaymentWindow(false)

                                        if (data?.link) {
                                            window.open(data?.link, '_blank', 'noopener,noreferrer');
                                        }
                                    }}
                                >
                                    Перейти к оплате
                                </Button>
                            </Box>
                    }

                </DialogContent>
            </Dialog>

            <Dialog
                open={showPMWindow}
                onClose={() => setShowPMWindow(false)}
            >
                <DialogContent>

                    <Typography align='center' variant="h5" sx={{ mb: 2, mt: 1 }}>
                        Выберите систему оплаты
                    </Typography>


                    <Box
                        display='flex'
                        justifyContent='center'
                        alignItems='center'
                        mt={2}
                    >
                        {PaymentMethods.map(item => {
                            if (!item.public) return null
                            return (
                                <Box
                                    key={item.value}
                                    display='flex'
                                    flexDirection='column'
                                    alignItems='center'
                                    mx={2}
                                    minWidth={100}
                                >
                                    <IconButton
                                        onClick={() => handleSelectPaymentMethod(item.value)}
                                        sx={{
                                            width: 64,
                                            height: 64,
                                            bgcolor: 'background.paper',
                                            borderRadius: '50%',
                                            p: 1,
                                            mb: 1,
                                            '&:hover': {
                                                bgcolor: 'action.hover'
                                            }
                                        }}
                                    >
                                        <img src={item.img} alt={item.name} style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover' }} />
                                    </IconButton>
                                    <Typography variant="body1" align="center">{item.name}</Typography>
                                    <Typography variant="body2" align="center">{item.method}</Typography>
                                </Box>
                            )

                        }

                        )}
                    </Box>

                </DialogContent>
            </Dialog>

            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={2}
                mt={1}
                flexDirection="column"
            >
                <Typography align="center" mb={0} variant={isMobile ? "body2" : "body1"} color="textSecondary">
                    {exchane.coins + ' ~ ' + exchane.usd + ' руб'}
                </Typography>

                <Box
                    display="flex"
                    alignItems="center"
                    flexDirection={isMobile ? "column" : "row"}
                    flexWrap={isMobile ? "nowrap" : "wrap"}
                    gap={isMobile ? 1 : 2}
                >
                </Box>

            </Box>



            <Box display="flex" gap={2} flexDirection='column'>

                <Box display="flex" gap={2} justifyContent="center">

                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <TextField
                            label="Ник вашего персонажа"
                            variant="outlined"
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value)
                            }}
                            onBlur={(e) => {
                                setErrorName(validator.isEmpty(e.target.value))
                            }}
                            error={errorName}
                        />
                    </FormControl>

                </Box>

                <Box display="flex" gap={2} justifyContent="center">
                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <InputLabel htmlFor="outlined-adornment-amount">Я оплачу</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-amount"
                            startAdornment={<InputAdornment position="start">₽</InputAdornment>}
                            label="Я оплачу"
                            value={amount}
                            onChange={(e) => handleAmountChange(e)}
                            error={errorAmount}
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <TextField
                            id="outlined-adornment-in-amount"
                            label="Я получу"
                            value={coin}
                            onChange={(e) => handleCoinChange(e)}
                            error={errorCoin}

                        />
                    </FormControl>
                </Box>

                <Box display="flex" gap={2} justifyContent="center">
                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <InputLabel id="game-label">Сервер</InputLabel>
                        <Select
                            labelId="game-label"
                            id="game-select"
                            value={server}
                            label="Сервер"
                            onChange={(e) => {
                                handleChangeServer(e)
                            }}
                        >
                            <MenuItem disabled value="">
                                <em>Сервер</em>
                            </MenuItem>

                            {serverArray.map(item =>
                                <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>
                            )}





                        </Select>
                    </FormControl>

                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <TextField
                            label="E-mail"
                            value={mail}
                            onChange={(e) => {
                                setMail(e.target.value)
                            }}
                            onBlur={(e) => {
                                handleMail(e)
                            }}
                            error={errorMail}
                        />
                    </FormControl>
                </Box>

                <Box justifyContent="center" display="flex" p={2}>
                    <Button
                        variant="contained"
                        onClick={handlePM}
                    >Оформить</Button>
                </Box>

            </Box>
        </>
    );
};

export default OrderBox;